<template>
    <div class="reflection-processing flex flex-col items-center gap-10 py-10">
        <div class="rp-stage" aria-hidden="true">
            <div class="rp-bowl"></div>
            <div class="rp-ball"></div>
        </div>
        <p class="rp-text body-small text-ink-muted">{{ label ?? t("reflections.self.processing") }}</p>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

interface Props {
    label?: string;
}

const { label } = defineProps<Props>();
const { t } = useI18n();
</script>

<style scoped>
.rp-stage {
    position: relative;
    width: 200px;
    height: 158px;
}

/* Warmer amber matches the self-reflection accent — mockup uses #FFD3A8 (bowl)
   and #FBB877 (ball). Not adding these to the design system yet since they're
   only used here; if the loading illustration returns elsewhere, promote to
   tokens. */
.rp-bowl {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 200px;
    height: 100px;
    background: #ffd3a8;
    border-radius: 0 0 100px 100px;
}

.rp-ball {
    position: absolute;
    left: 72px;
    bottom: 100px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #fbb877;
    will-change: transform;
    animation: rp-roll 1.5s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite alternate;
}

.rp-ball::before {
    content: "";
    position: absolute;
    top: 12px;
    left: 12px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: rgb(255 255 255 / 0.5);
}

@keyframes rp-roll {
    from {
        transform: translateX(-60px) rotate(-123deg);
    }
    to {
        transform: translateX(60px) rotate(123deg);
    }
}

.rp-text {
    animation: rp-pulse 1.6s ease-in-out infinite;
}

@keyframes rp-pulse {
    0%,
    100% {
        opacity: 0.6;
    }
    50% {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .rp-ball {
        animation: none;
        transform: rotate(0);
    }

    .rp-text {
        animation: none;
    }
}
</style>
